// App.jsx - wrapped from finance_hub.jsx
import React from 'react';
import './index.css';
// Reuse the entire finance hub component by importing it if modularized; for now, paste contents inline if needed.

// Load the main FinanceHub app component
import FinanceHub from './FinanceHub.jsx';
export default FinanceHub;
